export default __webpack_public_path__ + "f7887dc894671854af5aa5fd086d0578.png";